import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import * as XLSX from "xlsx";
import ExportToExcelBTN from "./ExportToExcelBTN";
import { useUser } from "../Contexts/UserContext";
import GetDate from "./GetDate";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 280px 280px;
  gap: 10px;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }
`;

const Card = styled.div`
  background-color: #f0f0f0;
  border-radius: 5px;
  padding: 20px;
  border: 2px solid black;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Card1 = styled(Card)`
  grid-row: 1;
  grid-column: 1;
`;

const Card2 = styled(Card)`
  grid-row: 1;
  grid-column: 2;
`;

const Card3 = styled(Card)`
  grid-row: 1 / span 2;
  grid-column: 3;

  @media (max-width: 768px) {
    grid-row: 3;
    grid-column: 1;
  }
`;

const Card4 = styled(Card)`
  grid-row: 2;
  grid-column: 1 / span 2;

  @media (max-width: 768px) {
    grid-row: 4;
    grid-column: 1;
  }
`;

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const StyledListItem = styled.li`
  padding: 10px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  background-color: #fff;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f0f0f0;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const PaginationButton = styled.button`
  margin: 0 5px;
  padding: 5px 10px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  background-color: #f0f0f0;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ccc;
  }
`;
const NumberDisplay = styled.div`
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;
const data1 = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "Dataset 1",
      data: [65, 59, 80, 81, 56, 55, 40],
      borderColor: "rgba(75,192,192,1)",
      backgroundColor: "rgba(75,192,192,0.2)",
    },
  ],
};

const data2 = {
  labels: ["August", "September", "October", "November", "December"],
  datasets: [
    {
      label: "Dataset 2",
      data: [30, 45, 67, 89, 70],
      borderColor: "rgba(192,75,75,1)",
      backgroundColor: "rgba(192,75,75,0.2)",
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Line Chart Example",
    },
  },
  elements: {
    line: {
      borderWidth: 2,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
};

const itemsPerPage = 5; // Number of items per page

const Component = () => {
  const [cardData, setCardData] = useState({ num: 0 });
  const [columnsHeaderToShow, setColumnsHeaderToShow] = useState([]);
  const [chartData, setChartData] = useState(data1);
  const [title, setTitle] = useState("Title 1");
  const [description, setDescription] = useState("Description for Title 1");
  const [tableData, setTableData] = useState([
    ["Row 1", "Data 1"],
    ["Row 2", "Data 2"],
    ["Row 3", "Data 3"],
    ["Row 4", "Data 4"],
    ["Row 5", "Data 5"],
  ]);
  const [currentPage, setCurrentPage] = useState(0);
  const { user } = useUser();
  const { CompCode, ClientId } = user;

  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  useEffect(() => {
    handleClick(
      1,
      [],
      "Un-Active User",
      "Users who did not scanned their QR Or Marked there Attendance",
      tableData
    );
  }, [ClientId]);
  const handleFetchData = async (itemNo) => {
    let response;
    if (itemNo == 1) {
      response = await fetch(
        `${API_URL}/facility/GetExceptionalReports/1/${CompCode}/${ClientId}/1/${GetDate()}`
      ).then((res) => res.json());
      if (response.success) {
        setCardData({ num: response.data.tableData.length });
        setTableData(response.data.tableData);
      }
      setColumnsHeaderToShow(["UnitName", "UserName", "Designation"]);
    } else if (itemNo == 2) {
      response = await fetch(
        `${API_URL}/facility/GetExceptionalReports/2/GU-4/${ClientId}/1/${GetDate()}`
      ).then((res) => res.json());
      if (response.success) {
        setCardData({ num: response.data.length });
      }
      setTableData(response.data);
      setColumnsHeaderToShow(["UnitName", "EmpCode", "EmpName"]);
    } else {
      response = await fetch(
        `${API_URL}/facility/GetExceptionalReports/3/GU-4/${ClientId}/1/${GetDate()}`
      ).then((res) => res.json());
      if (response.success) {
        setCardData({ num: response.data.length });
      }
      setTableData(response.data);
      setColumnsHeaderToShow(["DefaultUnit", "Unit", "EmpName"]);
    }
  };

  const handleClick = (
    itemNo,
    newData,
    newTitle,
    newDescription,
    newTableData
  ) => {
    handleFetchData(itemNo);
    setChartData(newData);
    setTitle(newTitle);
    setDescription(newDescription);
    // setTableData(newTableData);
    setCurrentPage(0); // Reset to the first page when changing data
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = tableData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const renderPagination = () => {
    const pagesToShow = 3; // Number of pages to show around the current page
    const pageNumbers = [];

    for (
      let page = Math.max(0, currentPage - pagesToShow);
      page <= Math.min(totalPages - 1, currentPage + pagesToShow);
      page++
    ) {
      pageNumbers.push(
        <PaginationButton
          key={page}
          onClick={() => handlePageChange(page)}
          style={{
            backgroundColor: currentPage === page ? "#ccc" : "#f0f0f0",
          }}
        >
          {page + 1}
        </PaginationButton>
      );
    }

    return (
      <PaginationContainer>
        {currentPage > 0 && (
          <>
            <PaginationButton onClick={() => handlePageChange(0)}>
              1
            </PaginationButton>
            {currentPage > 1 && <PaginationButton>...</PaginationButton>}
          </>
        )}

        {pageNumbers}

        {currentPage < totalPages - 1 && (
          <>
            {currentPage < totalPages - 2 && (
              <PaginationButton>...</PaginationButton>
            )}
            <PaginationButton onClick={() => handlePageChange(totalPages - 1)}>
              {totalPages}
            </PaginationButton>
          </>
        )}
      </PaginationContainer>
    );
  };

  return (
    <Container>
      <Card1>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <NumberDisplay>{cardData.num}</NumberDisplay>
          <div>
            <ExportToExcelBTN data={tableData} />
          </div>
        </div>
        <h2>{title}</h2>
        <p>{description}</p>
      </Card1>
      <Card2>
        <Line data={chartData} options={options} />
      </Card2>
      <Card3>
        <header>
          <h3>Exceptions</h3>
        </header>
        <StyledList>
          <StyledListItem
            onClick={() =>
              handleClick(
                1,
                data2,
                "Un-Active Users",
                "Users who did not scanned their QR Or Marked there Attendance",
                [
                  ["Row A", "Data A"],
                  ["Row B", "Data B"],
                  ["Row C", "Data C"],
                  ["Row D", "Data D"],
                  ["Row E", "Data E"],
                ]
              )
            }
          >
            Un-Active Users
          </StyledListItem>
          <StyledListItem
            onClick={() =>
              handleClick(
                2,
                data1,
                " Unknown Visitors",
                "Users which are not mapped under that client but they scanned our QR",
                [
                  ["Row 1", "Data 1"],
                  ["Row 2", "Data 2"],
                  ["Row 3", "Data 3"],
                  ["Row 4", "Data 4"],
                  ["Row 5", "Data 5"],
                ]
              )
            }
          >
            Unknown Visitors
          </StyledListItem>
          <StyledListItem
            onClick={() =>
              handleClick(
                3,
                data1,
                "User Augmentation",
                "Individuals marking their presence on another client or organization.",
                [
                  ["Row 1", "Data 1"],
                  ["Row 2", "Data 2"],
                  ["Row 3", "Data 3"],
                  ["Row 4", "Data 4"],
                  ["Row 5", "Data 5"],
                ]
              )
            }
          >
            User Augmentation
          </StyledListItem>
        </StyledList>
      </Card3>
      <Card4>
        <table>
          <thead>
            <tr>
              {columnsHeaderToShow.map((colName) => (
                <th key={colName}>{colName}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columnsHeaderToShow.map((colName) => (
                  <td key={colName}>{row[colName]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {totalPages > 1 && renderPagination()}
      </Card4>
    </Container>
  );
};
const DownloadButton = styled.button`
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 8px;
    padding: 5px;
  }
`;
export default Component;
